module.exports = __webpack_public_path__ + "static/img/accept-image.18d0749f.png";